import { componentBaseStyles } from '@adaptive-web/adaptive-ui';
import { accentForegroundRest } from '@adaptive-web/adaptive-ui/migration';
import { css } from '@microsoft/fast-element';

export default css`
	${componentBaseStyles}

	:host {
		display: inline flex;
	}
`;